export const images = 
  {
    'office': require("./alesia-kazantceva-XLm6-fPwK5Q-unsplash.jpg"),
    'paper':require("./christa-dodoo-MldQeWmF2_g-unsplash.jpg"),
    'desk':require("./jess-bailey-q10VITrVYUM-unsplash.jpg"),
    'metrics': require("./stephen-dawson-qwtCeJ5cLYs-unsplash.jpg"),
    'graph': require("./markus-winkler-IrRbSND5EUc-unsplash.jpg"),
    'code': require("./kevin-ku-w7ZyuGYNpRQ-unsplash.jpg")
  };